import { BundleOwner, User } from '@prisma/client';

import { Role } from '@app/domain-interfaces';
import { Auth } from '@app/web-components';

export const useBulkSubscribeAccess = () => {
  const { user } = Auth.useUserAuth();

  const canBulkSubscribeAccess = (record?: (BundleOwner & { owner: User })[]) =>
    user?.roles[Role.SYSTEM_ADMIN] || record?.some(({ owner }) => owner.id === user?.id);

  return { user, canBulkSubscribeAccess };
};
